<span *ngFor="let position of positions" [class.highlight]="position.highlight"><span *ngIf="!position.isDate">{{position.value}}</span><span *ngIf="position.isDate">{{position.value|withCityTz:city|dt:'dd.MM.yy'}}</span></span>
